import { TrashIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "components/AlertDialog";

import { ReactComponent as PriorityHigh } from "assets/priority_high.svg";

import { useDeleteSessionDialog } from "./useDeleteSessionDialog";

export default function DeleteSessionDialog({ sessionId }: { sessionId: string }) {
  const { t } = useTranslation();
  const { deleteSessionMutation } = useDeleteSessionDialog();

  return (
    <AlertDialog>
      <AlertDialogTrigger className="cursor-pointer">
        <TrashIcon className="size-5 cursor-pointer" />
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="w-20 h-20 m-auto mb-5 rounded-full flex items-center justify-center bg-general-orange-700 border border-general-orange-800">
            <PriorityHigh className="w-16 h-16 fill-general-orange-900" />
          </div>
          <AlertDialogTitle className="text-center">{t("session.cancelSessionDialog.title")}</AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            {t("session.cancelSessionDialog.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="w-full md:flex-1">{t("button.continue")}</AlertDialogCancel>
          <AlertDialogAction className="w-full md:flex-1" onClick={() => deleteSessionMutation.mutate(sessionId)}>
            {t("button.cancelSession")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
